<template>
  <div class="ficha-miembro">
    <p class="modal-hint">
      Familia:
      <strong v-if="etiquetaMostrada">{{ etiquetaMostrada }}</strong>
      <strong v-else class="tag is-danger tag-pendiente">POR ASIGNAR</strong>
    </p>

    <div class="miembro-head">
      <div class="foto-wrap">
        <img v-if="form.foto" :src="form.foto" class="foto-preview" alt="foto">
        <div v-else class="foto-preview is-empty"><b-icon icon="account" size="is-medium"></b-icon></div>
        <input ref="inputFoto" type="file" accept="image/*" class="foto-input" @change="cargarFoto">
        <b-button size="is-small" type="is-light" icon-left="camera" @click="$refs.inputFoto.click()">{{ form.foto ? 'Cambiar' : 'Foto' }}</b-button>
      </div>
      <div class="miembro-head-fields">
        <b-field grouped>
          <b-field label="Nombres *" expanded><b-input v-model="form.nombre" required></b-input></b-field>
          <b-field label="Apellidos *" expanded><b-input v-model="form.apellido" required></b-input></b-field>
        </b-field>
        <b-field grouped>
          <b-field label="Fecha de nacimiento *" expanded>
            <b-input type="date" v-model="form.fecha_nacimiento" required></b-input>
          </b-field>
          <b-field label="Edad" style="max-width:110px">
            <b-input :value="edadCalculada" disabled></b-input>
          </b-field>
        </b-field>
      </div>
    </div>

    <b-field grouped>
      <b-field label="Lugar de nacimiento *" expanded><b-input v-model="form.lugar_nacimiento" required></b-input></b-field>
      <b-field label="Ocupación *" expanded><b-input v-model="form.ocupacion" required></b-input></b-field>
    </b-field>
    <b-field grouped>
      <b-field label="Categoría (grupo del censo) *" expanded>
        <b-input v-model="form.categoria" list="categorias-censo" placeholder="Ej. Casados, Jóvenes, Niños…" :disabled="categoriaBloqueada" required></b-input>
        <datalist id="categorias-censo">
          <option value="Casados"></option><option value="Casadas"></option>
          <option value="Jóvenes"></option><option value="Señoritas"></option>
          <option value="Niños"></option><option value="Niñas"></option>
        </datalist>
      </b-field>
      <b-field label="Teléfono" expanded><b-input v-model="form.telefono"></b-input></b-field>
    </b-field>
    <b-field grouped>
      <b-field label="Dirección" expanded><b-input v-model="form.direccion" placeholder="Dirección completa"></b-input></b-field>
      <b-field label="Ciudad" expanded><b-input v-model="form.ciudad"></b-input></b-field>
    </b-field>

    <b-field v-if="mostrarSelectFamilia" label="Familia (censo)">
      <b-select v-model="form.familiaId" expanded>
        <option :value="''">Sin familia — por asignar</option>
        <option v-for="f in familias" :value="f.id" :key="f.id">{{ etiquetaDeFamilia(f) }}</option>
      </b-select>
    </b-field>

    <p class="section-label">Datos espirituales</p>
    <b-field>
      <b-switch v-model="form.es_espiritual" :true-value="1" :false-value="0">Ha recibido el Espíritu Santo</b-switch>
    </b-field>
    <b-field grouped>
      <b-field label="Fecha de bautismo" expanded><b-input type="date" v-model="form.fecha_bautismo"></b-input></b-field>
      <b-field label="Lugar de bautismo" expanded><b-input v-model="form.lugar_bautismo"></b-input></b-field>
      <b-field label="Ministro que bautizó" expanded><b-input v-model="form.ministro_bautizo"></b-input></b-field>
    </b-field>
    <b-field grouped v-if="form.es_espiritual">
      <b-field label="Fecha en que recibió" expanded><b-input type="date" v-model="form.fecha_recibio"></b-input></b-field>
      <b-field label="Ministro que testificó" expanded><b-input v-model="form.ministro_testifico"></b-input></b-field>
    </b-field>

    <template v-if="form.id">
      <p class="section-label">Historial de asistencia</p>
      <div class="hist">
        <div class="hist-filtros">
          <b-select v-model="histAnio" size="is-small" @input="cargarHistorial">
            <option :value="null">Todos los años</option>
            <option v-for="a in histAnios" :key="a" :value="a">{{ a }}</option>
          </b-select>
          <b-select v-model="histMes" size="is-small" @input="cargarHistorial">
            <option :value="null">Todos los meses</option>
            <option v-for="(n, i) in mesesNombres" :key="i + 1" :value="i + 1">{{ n }}</option>
          </b-select>
          <b-select v-model="histHora" size="is-small" @input="cargarHistorial">
            <option :value="null">Todos los horarios</option>
            <option v-for="h in histHoras" :key="h" :value="h">{{ etiquetaHora(h) }}</option>
          </b-select>
        </div>

        <div v-if="histCargando" class="hist-vacio">Cargando historial…</div>
        <div v-else-if="!historial" class="hist-vacio">Sin datos de asistencia.</div>
        <template v-else>
          <div class="hist-total">
            <span class="hist-total-txt">{{ historial.totales.presencias }} asistencias de {{ historial.totales.posibles }} posibles</span>
            <span class="pct" :class="pctClass(historial.totales.porcentaje)">{{ historial.totales.porcentaje }}%</span>
          </div>
          <div class="hist-bar"><div class="hist-bar-fill" :style="{ width: historial.totales.porcentaje + '%' }" :class="pctClass(historial.totales.porcentaje)"></div></div>

          <div class="hist-cols">
            <div class="hist-col">
              <p class="hist-sub">Mes a mes</p>
              <table class="hist-table">
                <thead><tr><th>Mes</th><th>Asistió</th><th>Posibles</th><th>%</th></tr></thead>
                <tbody>
                  <tr v-for="mm in mesesDesc" :key="mm.anio + '-' + mm.mes">
                    <td>{{ mesesNombres[mm.mes - 1] }} {{ mm.anio }}</td>
                    <td>{{ mm.presencias }}</td>
                    <td>{{ mm.posibles }}</td>
                    <td><span class="pct" :class="pctClass(mm.porcentaje)">{{ mm.porcentaje }}%</span></td>
                  </tr>
                  <tr v-if="!mesesDesc.length"><td colspan="4" class="hist-vacio">Sin meses en el periodo.</td></tr>
                </tbody>
              </table>
            </div>
            <div class="hist-col">
              <p class="hist-sub">Por horario</p>
              <table class="hist-table">
                <thead><tr><th>Horario</th><th>Asistió</th><th>Posibles</th><th>%</th></tr></thead>
                <tbody>
                  <tr v-for="h in historial.por_hora" :key="h.hora">
                    <td>{{ etiquetaHora(h.hora) }}</td>
                    <td>{{ h.presencias }}</td>
                    <td>{{ h.posibles }}</td>
                    <td><span class="pct" :class="pctClass(h.porcentaje)">{{ h.posibles ? h.porcentaje + '%' : '—' }}</span></td>
                  </tr>
                  <tr v-if="!historial.por_hora.length"><td colspan="4" class="hist-vacio">Sin registros.</td></tr>
                </tbody>
              </table>
            </div>
          </div>
        </template>
      </div>
    </template>

    <template v-if="mostrarNotas">
      <p class="section-label">Notas ministeriales <span class="muted">(solo visibles para el administrador)</span></p>
      <b-field><b-input type="textarea" v-model="form.notas" placeholder="Notas del ministro…"></b-input></b-field>
    </template>

    <b-field grouped>
      <b-button type="is-primary" :disabled="!esValido" @click="emitirGuardar">Guardar</b-button>
      <b-button @click="$emit('cancelar')">Cancelar</b-button>
    </b-field>
  </div>
</template>

<script>
import HttpService from '../../Servicios/HttpService'

const MESES = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre']
const HORAS = {
  '05:00': 'Oración 5:00 AM',
  '07:00': 'Dominical 7:00 AM',
  '09:00': 'Oración 9:00 AM',
  '18:00': 'Servicio especial 6:00 PM',
  '19:00': 'Oración 7:00 PM',
  '(otro)': 'Otro horario'
}

const VACIO = () => ({
  id: null, nombre: '', apellido: '', telefono: '', direccion: '', ciudad: '', edad: null,
  fecha_nacimiento: '', lugar_nacimiento: '', ocupacion: '', categoria: '',
  fecha_bautismo: '', lugar_bautismo: '', ministro_bautizo: '',
  es_espiritual: 0, fecha_recibio: '', ministro_testifico: '', notas: '',
  familiaId: null, grupoId: null, foto: null, fotoNueva: false
})

export function formMiembroVacio(){ return VACIO() }

export default {
  name: 'FormMiembro',
  props: {
    miembro: { type: Object, default: null },
    foto: { type: String, default: null },
    etiquetaFamilia: { type: String, default: null },
    mostrarNotas: { type: Boolean, default: false },
    mostrarSelectFamilia: { type: Boolean, default: false },
    familias: { type: Array, default: () => [] },
    categoriaDefecto: { type: String, default: '' },
    categoriaBloqueada: { type: Boolean, default: false }
  },
  data(){
    return {
      form: VACIO(),
      mesesNombres: MESES,
      historial: null,
      histCargando: false,
      histAnio: null,
      histMes: null,
      histHora: null,
      histAnios: [],
      histHoras: []
    }
  },
  computed: {
    edadCalculada(){
      if(!this.form.fecha_nacimiento) return this.form.edad || '—'
      const nac = new Date(this.form.fecha_nacimiento + 'T00:00:00')
      if(isNaN(nac)) return '—'
      const hoy = new Date()
      let e = hoy.getFullYear() - nac.getFullYear()
      const m = hoy.getMonth() - nac.getMonth()
      if(m < 0 || (m === 0 && hoy.getDate() < nac.getDate())) e--
      return e >= 0 ? e : '—'
    },
    esValido(){
      const f = this.form
      return !!(f.nombre && f.apellido && f.fecha_nacimiento && f.lugar_nacimiento && f.ocupacion && f.categoria)
    },
    etiquetaMostrada(){
      if(this.mostrarSelectFamilia){
        const f = this.familias.find(x => String(x.id) === String(this.form.familiaId))
        return f ? this.etiquetaDeFamilia(f) : null
      }
      return this.etiquetaFamilia
    },
    mesesDesc(){
      if(!this.historial || !this.historial.meses) return []
      return [...this.historial.meses].sort((a, b) => (b.anio * 100 + b.mes) - (a.anio * 100 + a.mes))
    }
  },
  watch: {
    miembro: {
      immediate: true,
      handler(v){
        this.form = Object.assign(VACIO(), v || {})
        if(this.form.familiaId === null || this.form.familiaId === undefined) this.form.familiaId = ''
        // categoría por defecto según el grupo del usuario (sólo en miembro nuevo)
        if(!this.form.id && !this.form.categoria && this.categoriaDefecto) this.form.categoria = this.categoriaDefecto
        this.historial = null
        this.histAnio = null; this.histMes = null; this.histHora = null
        if(this.form.id) this.cargarHistorial()
      }
    },
    categoriaDefecto(v){ if(!this.form.id && v) this.form.categoria = v },
    foto(v){ if(v !== undefined) this.form.foto = v }
  },
  methods: {
    etiquetaHora(h){ return HORAS[h] || h },
    pctClass(p){
      if(p >= 60) return 'pct-alta'
      if(p >= 30) return 'pct-media'
      return 'pct-baja'
    },
    cargarHistorial(){
      if(!this.form.id) return
      this.histCargando = true
      HttpService.obtenerConConsultas('familias.php', {
        accion: 'historial_miembro',
        miembroId: this.form.id,
        anio: this.histAnio,
        mes: this.histMes,
        hora: this.histHora
      }).then(r => {
        this.histCargando = false
        if(!r || r.error){ this.historial = null; return }
        this.historial = r
        // opciones de filtros: se acumulan para no perder horarios entre filtros
        if(r.anios) this.histAnios = [...new Set([...this.histAnios, ...r.anios])].sort()
        if(r.horas) this.histHoras = [...new Set([...this.histHoras, ...r.horas])].sort()
      }).catch(() => { this.histCargando = false; this.historial = null })
    },
    etiquetaDeFamilia(f){
      return [f.apellido, f.nombre].filter(Boolean).join(', ') || 'Familia'
    },
    cargarFoto(ev){
      const file = ev.target.files && ev.target.files[0]
      if(!file) return
      if(file.size > 3 * 1024 * 1024){
        this.$buefy.toast.open({ type: 'is-danger', message: 'La foto no debe pasar de 3 MB' })
        return
      }
      const reader = new FileReader()
      reader.onload = e => { this.form.foto = e.target.result; this.form.fotoNueva = true }
      reader.readAsDataURL(file)
      ev.target.value = ''
    },
    emitirGuardar(){
      const f = this.form
      this.$emit('guardar', {
        id: f.id,
        nombre: f.nombre, apellido: f.apellido, telefono: f.telefono,
        direccion: f.direccion, ciudad: f.ciudad,
        fecha_nacimiento: f.fecha_nacimiento || null,
        edad: f.fecha_nacimiento ? this.edadCalculada : f.edad,
        lugar_nacimiento: f.lugar_nacimiento, ocupacion: f.ocupacion, categoria: f.categoria,
        fecha_bautismo: f.fecha_bautismo || null, lugar_bautismo: f.lugar_bautismo, ministro_bautizo: f.ministro_bautizo,
        es_espiritual: f.es_espiritual ? 1 : 0,
        fecha_recibio: f.fecha_recibio || null, ministro_testifico: f.ministro_testifico,
        notas: f.notas,
        familiaId: f.familiaId === '' ? null : f.familiaId, grupoId: f.grupoId,
        foto: f.foto, fotoNueva: f.fotoNueva
      })
    }
  }
}
</script>

<style scoped>
.modal-hint{ color: var(--text-muted); font-size: .82rem; margin-top: -.5rem; margin-bottom: 1rem; }
.modal-hint .tag-pendiente{ font-size: .72rem; letter-spacing: .04em; }
.muted{ color: var(--text-muted); font-weight: 400; }
.section-label{
  font-size: .68rem; font-weight: 700; letter-spacing: .08em; text-transform: uppercase;
  color: #9aa0b8; margin: 1.1rem 0 .6rem; border-top: 1px solid var(--border); padding-top: 1rem;
}
.miembro-head{ display: flex; gap: 1.1rem; align-items: flex-start; margin-bottom: .4rem; }
.miembro-head-fields{ flex: 1; }
.foto-wrap{ display: flex; flex-direction: column; align-items: center; gap: .45rem; }
.foto-preview{
  width: 86px; height: 86px; border-radius: 16px; object-fit: cover;
  border: 1px solid var(--border);
}
.foto-preview.is-empty{
  background: #f4f5fa; color: #b9c0d8;
  display: flex; align-items: center; justify-content: center;
}
.foto-input{ display: none; }

/* Historial de asistencia */
.hist{ background: #fafbfe; border: 1px solid var(--border); border-radius: 12px; padding: .8rem .9rem; }
.hist-filtros{ display: flex; gap: .5rem; flex-wrap: wrap; margin-bottom: .6rem; }
.hist-filtros .select{ flex: 1; min-width: 130px; }
.hist-filtros .select select{ width: 100%; }
.hist-vacio{ color: var(--text-muted); font-size: .8rem; padding: .4rem 0; }
.hist-total{ display: flex; justify-content: space-between; align-items: center; font-size: .82rem; color: #555d78; }
.hist-bar{ height: 7px; background: #e8eaf3; border-radius: 99px; overflow: hidden; margin: .35rem 0 .7rem; }
.hist-bar-fill{ height: 100%; border-radius: 99px; transition: width .3s ease; }
.hist-bar-fill.pct-alta{ background: #28a745; }
.hist-bar-fill.pct-media{ background: #e6a23c; }
.hist-bar-fill.pct-baja{ background: #dc3545; }
.hist-cols{ display: grid; grid-template-columns: 1fr 1fr; gap: .9rem; }
@media (max-width: 640px){ .hist-cols{ grid-template-columns: 1fr; } }
.hist-sub{ font-size: .7rem; font-weight: 700; letter-spacing: .05em; text-transform: uppercase; color: #9aa0b8; margin-bottom: .3rem; }
.hist-table{ width: 100%; font-size: .78rem; border-collapse: collapse; }
.hist-table th{ text-align: left; color: var(--text-muted); font-weight: 600; font-size: .68rem; text-transform: uppercase; letter-spacing: .04em; padding: .25rem .3rem; border-bottom: 1px solid var(--border); }
.hist-table td{ padding: .3rem; border-bottom: 1px solid #eef0f7; color: #3d4359; }
.hist-table tbody tr:last-child td{ border-bottom: none; }
.pct{ font-weight: 700; font-size: .76rem; }
.pct.pct-alta{ color: #28a745; }
.pct.pct-media{ color: #e6a23c; }
.pct.pct-baja{ color: #dc3545; }
</style>
